import { Facebook, Twitter, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import logo from '@/assets/logo.png';
import logoAdv77 from '@/assets/logo-adv77.png';

// Payment icons as styled components
const PayPalIcon = () => (
  <div className="bg-white rounded-md px-4 py-2 flex items-center justify-center min-w-[70px] h-[38px] gap-1">
    <svg viewBox="0 0 24 24" className="h-5 w-5">
      <path fill="#003087" d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106z"/>
      <path fill="#0070E0" d="M23.95 7.209c-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.48 9.386a.539.539 0 0 0 .533.617h3.726c.458 0 .85-.334.92-.788l.038-.196.73-4.623.047-.255a.93.93 0 0 1 .92-.789h.58c3.76 0 6.705-1.528 7.566-5.946.36-1.847.174-3.388-.777-4.471a3.71 3.71 0 0 0-.839-.669z"/>
    </svg>
    <span className="text-[#003087] font-bold text-sm">Pay</span>
    <span className="text-[#0070E0] font-bold text-sm">Pal</span>
  </div>
);

const MastercardIcon = () => (
  <div className="bg-white rounded-md px-4 py-2 flex flex-col items-center justify-center min-w-[70px] h-[38px]">
    <div className="flex items-center">
      <div className="w-5 h-5 rounded-full bg-[#eb001b]"></div>
      <div className="w-5 h-5 rounded-full bg-[#f79e1b] -ml-2 opacity-90"></div>
    </div>
    <span className="text-[8px] font-medium text-gray-800 tracking-wider mt-0.5">mastercard</span>
  </div>
);

const VisaIcon = () => (
  <div className="bg-white rounded-md px-4 py-2 flex items-center justify-center min-w-[70px] h-[38px]">
    <svg viewBox="0 0 48 16" className="h-4" preserveAspectRatio="xMidYMid">
      <path fill="#1434CB" d="M17.545 1.022L11.461 15H7.643L4.626 4.012c-.183-.72-.342-1.004-.899-1.313C2.762 2.185 1.26 1.69 0 1.383l.095-.36h6.153c.784 0 1.489.522 1.668 1.425l1.522 8.095 3.764-9.52h3.843zm15.182 9.406c.016-3.683-5.092-3.886-5.058-5.532.011-.5.488-1.033 1.532-1.169.518-.068 1.946-.12 3.565.627l.635-2.963C32.447 1.054 31.208.67 29.682.67c-3.618 0-6.165 1.924-6.186 4.68-.023 2.038 1.818 3.175 3.206 3.853 1.428.695 1.907 1.14 1.901 1.762-.01.952-1.139 1.372-2.193 1.389-1.842.028-2.911-.498-3.764-.895l-.664 3.103c.856.393 2.438.736 4.078.753 3.845 0 6.358-1.9 6.367-4.887zm9.553 4.574h3.387L42.719 1.022h-3.126a1.654 1.654 0 0 0-1.547 1.032l-5.454 12.948h3.818l.758-2.101h4.67l.442 2.101zm-4.062-4.984l1.916-5.287 1.103 5.287h-3.019zm-15.33-9.996l-3.018 13.98H16.19l3.018-13.98h3.68z"/>
    </svg>
  </div>
);

const KlarnaIcon = () => (
  <div className="bg-[#ffb3c7] rounded-md px-4 py-2 flex items-center justify-center min-w-[70px] h-[38px]">
    <span className="text-black font-bold text-sm tracking-tight">Klarna.</span>
  </div>
);

const AmexIcon = () => (
  <div className="bg-[#016fd0] rounded-md px-3 py-2 flex items-center justify-center min-w-[70px] h-[38px]">
    <svg viewBox="0 0 60 20" className="h-4" fill="white">
      <text x="2" y="14" fontFamily="Arial Black, sans-serif" fontSize="10" fontWeight="900" letterSpacing="-0.5">AMERICAN</text>
      <text x="6" y="19" fontFamily="Arial Black, sans-serif" fontSize="5" fontWeight="700" letterSpacing="0.5">EXPRESS</text>
    </svg>
  </div>
);

export const Footer = () => {
  return (
    <footer className="bg-[#0a1628] text-white">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img src={logo} alt="Materialidtf.it" width={144} height={48} className="h-12 w-auto" />
            </Link>
            <p className="text-gray-400 mb-6 text-sm">
              Il tuo partner di fiducia per materiali DTF e DTF UV di alta qualità.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-primary transition-colors" aria-label="Seguici su Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-primary transition-colors" aria-label="Seguici su Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center hover:bg-primary transition-colors" aria-label="Seguici su Instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Link Rapidi */}
          <div>
            <h4 className="font-bold mb-4 text-lg">Link Rapidi</h4>
            <ul className="space-y-3 text-gray-400">
              <li><Link to="/inchiostri" className="hover:text-primary transition-colors">Inchiostri</Link></li>
              <li><Link to="/bobine" className="hover:text-primary transition-colors">Bobine</Link></li>
              <li><Link to="/colla" className="hover:text-primary transition-colors">Colla</Link></li>
              <li><Link to="/ricambi" className="hover:text-primary transition-colors">Ricambi</Link></li>
              <li><Link to="/assistenza" className="hover:text-primary transition-colors">Assistenza</Link></li>
            </ul>
          </div>

          {/* Servizi */}
          <div>
            <h4 className="font-bold mb-4 text-lg">Servizi</h4>
            <ul className="space-y-3 text-gray-400">
              <li><Link to="/profilatura" className="hover:text-primary transition-colors">Profilatura</Link></li>
              <li><Link to="/stampa-dtf" className="hover:text-primary transition-colors">Stampa DTF</Link></li>
              <li><Link to="/stampa-dtf-uv" className="hover:text-primary transition-colors">Stampa DTF UV</Link></li>
              <li><Link to="/supporto-tecnico" className="hover:text-primary transition-colors">Supporto Tecnico</Link></li>
            </ul>
          </div>

          {/* Contatti */}
          <div>
            <h4 className="font-bold mb-4 text-lg">Contatti</h4>
            <ul className="space-y-4 text-gray-400">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <span>Via Don Minzoni 15, 00013 Fonte Nuova (RM), Italia</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-primary flex-shrink-0" />
                <span>+39 375 7190556</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary flex-shrink-0" />
                <span>info@materialidtf.it</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Payment Methods Section */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-8">
          <h4 className="text-center font-bold mb-6">Metodi di Pagamento</h4>
          <div className="flex flex-wrap justify-center gap-3">
            <PayPalIcon />
            <MastercardIcon />
            <VisaIcon />
            <KlarnaIcon />
            <AmexIcon />
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-gray-400 text-sm">
            <p>&copy; {new Date().getFullYear()} Materialidtf.it. Tutti i diritti riservati.</p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy Policy</Link>
              <Link to="/termini-condizioni" className="hover:text-primary transition-colors">Termini e Condizioni</Link>
              <Link to="/cookie-policy" className="hover:text-primary transition-colors">Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Credits */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-center gap-2 text-gray-300 text-xs">
            <span>Sito realizzato da</span>
            <a href="https://adv77.it" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 hover:opacity-80 transition-opacity">
              <img src={logoAdv77} alt="ADV77" width={84} height={28} className="h-7 w-auto drop-shadow-[0_0_8px_rgba(255,255,255,0.8)]" />
              <span className="text-gray-300">Digital Agency</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
